import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Mail, MapPin, Heart } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-gradient-to-br from-purple-400 to-teal-400 flex items-center justify-center">
                <Shield className="w-6 h-6 text-white" />
              </div>
              <span className="text-xl font-bold">SafeShe Atlas</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Empowering women travelers with real-time safety insights and data-driven rankings across global destinations.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/rankings" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Global Rankings
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-teal-400 transition-colors text-sm">
                  Contact
                </Link>
              </li>

              {/* Safety Advisory */}
              <li>
                <Link 
                  to="/disclaimer"
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
                >
                  Safety Advisory / Disclaimer
                </Link>
              </li>

              {/* ⭐ New Photo Credits Link */}
              <li>
                <Link 
                  to="/photo-credits"
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
                >
                  Photo Credits
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-teal-400 mt-0.5" />
                <span className="text-gray-400 text-sm">stay-safe@safesheatlas.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-teal-400 mt-0.5" />
                <span className="text-gray-400 text-sm">Global Coverage, Real-time Updates</span>
              </li>
            </ul>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm flex items-center justify-center gap-2">
            Made with <Heart className="w-4 h-4 text-red-500 fill-current" /> for women's safety worldwide
          </p>
          <p className="text-gray-500 text-xs mt-2">
            © {new Date().getFullYear()} SafeShe Atlas. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
